export const SET_NOTIFICATIONS = "SET_NOTIFICATIONS"
export const SET_NOTIFICATIONS_MENU = "SET_NOTIFICATIONS_MENU"
export const RESTORE_NOTIFICATIONS = "RESTORE_NOTIFICATIONS"
